import * as JsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'

export default {
  props: ['idTabela', 'orientacao', 'tituloTabela','descricoes','entrada', 'retorno','resultados', 'nomeArquivo', 'nomeImagemParceiro'],

  data () {
    return {
      tamanhoLinha: 0,
      tamanhoTotal: 0
    }
  },
  methods: {
    configuraSubtitulo (opcoes) {
       opcoes.headerStyles={}
       opcoes.headerStyles.fillColor=[96,168,216] 
       opcoes.headerStyles.halign = "left"
       opcoes.startY-=5
    },

 
    gerarOpcoes (doc, espacamento, numeroPagina, linhas, titulo, primeiro) {

      let vm = this;
      let poweredText;
      let pageCounter;
      let titleMarginLeft;

       if (this.orientacao === 'p') {
        poweredText = 570;
        pageCounter = 400;
        titleMarginLeft = 250;
      } else {
        poweredText = 570;
        pageCounter = 660;
        titleMarginLeft = 400;
      }

      let header = function (data) {
        doc.setFontSize(16);
        doc.setTextColor(40);
        doc.setFontStyle('normal');
        doc.text(titleMarginLeft, 36, "");

        doc.setFontStyle('normal');
 
      };

      let footer = function(data) {
        doc.setFontSize(10);
        if (numeroPagina !== doc.internal.getNumberOfPages()) {
          vm.tamanhoLinha = 0
          espacamento = 0
          numeroPagina = doc.internal.getNumberOfPages()
          doc.text(40, poweredText, String(numeroPagina))
          doc.text(pageCounter, poweredText, 'Powered by Rancho Soluções');
        } 
      };

      let py = [];
      
      let options = {
        theme: 'striped',
        startY: primeiro ? 150 : doc.autoTableEndPosY() + 2,
        styles: {
          overflow: 'linebreak',
        },
        margin: {
          top: 30,
          bottom: 30
        },
        columnStyles:{
          0: {
            columnWidth: 260,
          },
          1: {
            columnWidth:130,
            halign: 'right',
            fontStyle: 'bold'
          },
          2: {
            columnWidth:260,
          },
          3: {
            columnWidth:130,
            halign: 'right',
            fontStyle: 'bold'                    
          }
         
        },
        drawHeaderRow (row, data) {
          py.push(row.y + 15)
        },
        drawRow (row, data) {
          vm.tamanhoLinha += row.height
          vm.tamanhoTotal += row.height
          if (vm.tamanhoLinha >= 560 ) {
            vm.tamanhoLinha = 0
            doc.addPage()
            espacamento = 0
          }
        },
        addPageContent: (data) => {
          header(data);
          footer(data);
          
          if (titulo) {
            let titulos = Array.isArray(titulo) ? titulo : [titulo]
            let posY = py.pop()
            for(var i = 0; i < titulos.length; i++) {
              let titulo = titulos[i]
              doc.setTextColor (255,255,255)
              doc.setFontSize (12)
              doc.setFontType ("bold")
              if (titulo.subtitulo) {
                doc.text(titulo.texto, 50, posY)
              } else {
                if (titulo.subtitulo1) {
                  doc.text(titulo.texto, 440, posY)
                } else {
                  doc.text(titulo, 425, posY, 'center')
                }  
              }
            }

          }
        },
        drawCell: (cell, data) => {
        
        }
      };

      espacamento = espacamento + (linhas.length + 2);
      return {
        opcoes: options,
        numeroPagina: numeroPagina,
        espacamento: espacamento
      };

    },
    criarPDF () {

      let doc = new this.$JsPDF(this.orientacao, 'pt');

      this.entrada = this.$utils.exportaPdf.trataEntrada(this.entrada)
      
      let espacamento = 0;
      let numeroPagina = 0;
      let opcoes = {};
      let resp = {};
      this.tamanhoLinha = 0
      this.tamanhoTotal = 0

      this.$utils.exportaPdf.adicionaLogosConsolidado(doc, this.nomeImagemParceiro)

      doc.setFontSize (12)

      doc.setFontType ("bold")
      doc.text ('Relatório (Pasto - Simulação Avançado)',250,50)

      let px = 280
      let px2 = 425
      doc.setFontSize (10)

      doc.setFontType ("normal")
      doc.text ('Nome da Propiedade:',px,80)
      doc.setFontType ("bold")
      doc.text (this.entrada.informacoes.produtiva.propriedade,px2,80)

      doc.setFontType ("normal")
      doc.text ('Nome da simulação:',px,100)
      doc.setFontType ("bold")
      doc.text (this.entrada.nome,px2,100)
      
      doc.setFontType ("normal")
      doc.text ("Data da simulação:",px,120)
      doc.setFontType ("bold")
      doc.text (this.retorno.criado_em,px2,120)

      doc.setFontType ("normal")
      doc.text ("Estágio do negócio:",px,140)
      doc.setFontType ("bold")
      doc.text (this.entrada.estagioNegocio,px2,140)

     
    //============================================================================================== 
    // Informações Produtivas e financeiras
    //==============================================================================================

    let colunas =  ['',
    '',
    '',
    '']

    let linhas = [
      ["Total de Animais do lote",
      this.entrada.informacoes.produtiva.totalAnimaisLote,
      "Cidade de Origem",
      this.entrada.informacoes.produtiva.cidade],

      ["Raça dos animais",
      this.entrada.informacoes.produtiva.racaAnimais,
      "Estado de origem",
      this.entrada.informacoes.produtiva.estado],
            
      ["Padrão racial",
      this.entrada.informacoes.produtiva.padraoRacial && this.entrada.informacoes.produtiva.padraoRacial[0] ? this.entrada.informacoes.produtiva.padraoRacial[0].label :  '',
      "Frigorífico",
      this.entrada.informacoes.produtiva.frigorifico],

      ["Sexo dos animais",
      this.entrada.informacoes.produtiva.sexoAnimais.label,
      "Rendimento de carcaça de entrada",
      this.entrada.informacoes.produtiva.rendimentoCarcacaEntrada + " %"],
      

      ["Mortalidade",
      this.entrada.informacoes.produtiva.mortalidade + " %",
      "Rendimento de carcaça de abate",
      this.entrada.informacoes.produtiva.rendimentoCaracaAbate + " %"],
      

      ["Idade de entrada meses",
      this.entrada.informacoes.produtiva.idadeEntradaMeses,
      "UA média ciclo",
      this.entrada.informacoes.produtiva.uaMediaCiclo + " Ua/ha"],

      ["",
      ""]
    ]

    resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Informações Produtivas", true)
    opcoes = resp.opcoes;
    numeroPagina = resp.numeroPagina;
    espacamento = resp.espacamento;
    doc.autoTable(colunas, linhas, opcoes)

      //**************************************************************** */
      // FASES
      let configColunas = { columnWidth: 'auto', fontSize: 9, halign: 'center' }
      let columnStyles = {
        0: configColunas,
        1: {columnWidth: 60, fontSize: 9, halign: 'center'},
        2: {columnWidth: 60, fontSize: 9, halign: 'center'},
        3: configColunas,
        4: configColunas,
        5: configColunas,
        6: configColunas,
        7: configColunas,
        8: configColunas,
        9: configColunas,
        10: configColunas,
        11: configColunas,
        12: configColunas
      }

      function _pegaFase(ind, fase) {
        fase.duracao = moment(fase.dataFinal, 'DD/MM/YYYY').diff(moment(fase.dataInicial, 'DD/MM/YYYY'), 'day', false)
        return [ind, fase.dataInicial, fase.dataFinal, fase.duracao, fase.gmdKgd, fase.pesoInicial, fase.pesoFinal, fase.pesoMedio, fase.suplemento, fase.consumoPV, fase.consumoKG, fase.preco, fase.custo]
      }

      let linhasFase = []
      linhasFase.push(['Fase', 'Data Inicial', 'Data Final', 'Duração, d', 'GMD, kg/d', 'Peso Inicial', 'Peso Final', 'Peso Médio', 'Suplemento', 'Consumo,\n% do PV', 'Consumo, kg/cab/d', 'Preço, R$/kg', 'Custo total, R$/cab'])
      
      for(let i = 1; i < 9; i++) {
        doc.setFontSize (9)
        let chave = `fase_${i}`
        if(!this.entrada.informacoes.ciclo[chave]) break
        linhasFase.push(_pegaFase(i, this.entrada.informacoes.ciclo[chave]))
      }

      let consolidado = this.entrada.informacoes.ciclo.consolidado
      linhasFase.push(['', 'Consolidado',consolidado.dataFinal, consolidado.duracao, consolidado.gmdKgd, consolidado.pesoInicial, consolidado.pesoFinal, consolidado.pesoMedio, consolidado.suplemento, consolidado.consumoPV, consolidado.consumoKG, consolidado.preco, consolidado.custo])
      
      colunas = ['','','','','','','','','','','','','']
      
      linhas = linhasFase

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Fases do ciclo produtivo")
      opcoes = resp.opcoes;
      opcoes.columnStyles = columnStyles
      opcoes.margin.left = 40
      opcoes.margin.right = 23
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)
      doc.addPage()
      //**************************************************************** */
      //                            "Informações Financeiras"

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   

      ["Valor do gado/CAB CIF",
      "R$ " + this.entrada.informacoes.financeira.valorGadoCabecaCIF,
      "Depreciação",
      "R$ " + this.entrada.informacoes.financeira.depreciacao + " /cab"],

      ["Data de pagamento do gado",
      this.entrada.informacoes.financeira.dataPagamentoGado,
      "Amortização",
      "R$ " + this.entrada.informacoes.financeira.amortizacao + " /cab"],   

      ["Taxa de remuneração capital do gado % am",
      this.entrada.informacoes.financeira.taxaRemuneracaoCapital + " %", 
      "Não operacional",
      "R$ " + this.entrada.informacoes.financeira.naoOperacional + " /cab"],
      
      ["Dias entre embarque e abate",
      this.entrada.informacoes.financeira.diasEntreEmbarqueAbate,
      "Imposto de renda",
      "R$ " + this.entrada.informacoes.financeira.impostoRenda + " /cab"],

      ["Dias entre abate e recebimento",
      this.entrada.informacoes.financeira.diasEntreAbateRecebimento,
      "Preço de venda",
      "R$ " +  this.entrada.informacoes.financeira.precoVenda + " /cab"],

      ["Dias extras para recebimento",
      this.entrada.informacoes.financeira.diasExtrasRecebimento,
      "Diferencial base",
      "R$ " +  this.entrada.informacoes.financeira.diferencialBase + " /@"],

      ["Preço referência boi gordo",
      "R$ " +  this.entrada.informacoes.financeira.precoReferenciaBoiGordo + "/ @",
      "Descondo aplicado venda a vista",
       this.entrada.informacoes.financeira.descontoAplicadoVendaVista + " %"],

      ["Custo variável exceto nutrição",
      "R$ " + this.entrada.informacoes.financeira.custoVariavelExcetoNutricao + " /CAB/Mês",
      "Prêmio EU",
      "R$ " +  this.entrada.informacoes.financeira.premioEU + " /@"],    

      ["Custo fixo total",
      "R$ " + this.entrada.informacoes.financeira.custoFixoTotal + " /CAB",
      "Prêmio Hilton",
      "R$ " + this.entrada.informacoes.financeira.premioHilton + " /@"],

      ["Despesas por mês",
      "R$ " + this.entrada.informacoes.financeira.despesasCabecasMes + " /CAB/Mês",
      "Prêmio Angus",
      "R$ " + this.entrada.informacoes.financeira.premioAngus + " /@"],

      ["Despesas de comercialização",
      "R$ " + this.entrada.informacoes.financeira.despesasComercializacao + " cab",
      "Prêmio de acabamento",
      "R$ " + this.entrada.informacoes.financeira.premioAcabamento + " /@"],

      ["Deduções aplicadas ROB",
       this.entrada.informacoes.financeira.deducoesAplicadasROB + " %",
      "Outros prêmios",
      "R$ " + this.entrada.informacoes.financeira.outrosPremios + '/@'],

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Informações Financeiras", true)
      opcoes = resp.opcoes;
      opcoes.startY = 40
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)


      //********************************************************
      // "RESULTADOS PRODUTIVOS E ECONÔMICOS PRINCIPAIS"
                                
      colunas =  ['',
      '',
      '',
      '']

      linhas = [   

      ["Peso de saída KG",
      this.resultados.principais.pesoSaidaKg,
      "Custo da @ entrada (magra)",
      "R$ " + this.resultados.principais.custoArrobaEntradaMagra + " /@"],

      ["Peso de saída @",
      this.resultados.principais.pesoSaidaArroba,
      "Custo @ Vendida",
      "R$ " + this.resultados.principais.custoArrobaVendida + " /@"],
                            
      ["Data do abate",
      this.resultados.principais.dataAbate,           
      "Custo por @ produzida",
      "R$ " + this.resultados.economicos.analise.custo.custoArrobaProduzida + " /@"],
 
      ["Taxa mensal capital investido",
      this.resultados.principais.taxaMensalCapitalInvestidoGado + " %",
      "Custeio ao mês",
      "R$ " + this.resultados.principais.custeio + " /cab"],
                             
      ["Lucro líquido",
      "R$ " + this.resultados.principais.lucroLiquido + " /cab",
      "Lucro líquido, R$/ha/ciclo produtivo",
      "R$ " + this.resultados.principais.lucroLiquidoCicloProdutivo],
      
      ["Data de liquidação financeira",
      this.resultados.principais.dataLiquidacaoFinanceira,
      "Lucro líquido, R$/ha/ciclo anualizado",
      "R$ " + this.resultados.principais.lucroLiquidoCicloAnualizado],
      
      ["Preço @ vendida livre",
      "R$ " + this.resultados.principais.precoArrobaVendidaLivre + " /@",
      "",""],

      ["","","",""],
      ["","","",""],
      ["","","",""]
      

          
      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Principais", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)


      //*
      // " Resultados Produtivos

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                  
      ["Peso de Entrada Kg",
      this.resultados.produtivos.pesoEntradaKg,
      "Peso de Saída Kg Cardaça Quente",
      this.resultados.produtivos.pesoSaidaKgCarcacaQuente],

      ["Peso de Saída Kg",
      this.resultados.produtivos.pesoSaidaKg,
      "Quantidade de @ Produzida /Cabeça",
      this.resultados.produtivos.quantidadeArrobaProduzidadaCabeca],
                                
      ["Peso vivo médio durante ciclo produtivo em Kg",
      this.resultados.produtivos.pesoVivoMedioDuranteCicloProdutivoKg,
      "Quantidade de @ produzida (@/lote)",
      this.resultados.produtivos.quantidadeArrobaProduzidadaLote],

      ["Peso vivo colocado em Kg",
      this.resultados.produtivos.pesoVivoColocadoKg,
      "Quantidade de @ abatida (@/lote)",
      this.resultados.produtivos.quantidadeArrobaAbatidasLote],
                                
      ["Peso de Entrada @",
      this.resultados.produtivos.pesoEntradaArroba,
      "Quantidade de contratos BMF (Proteção Lote)",
      this.resultados.produtivos.quantidadeContratosBmfProtecaoLote],

      ["Peso de Sáida @",
      this.resultados.produtivos.pesoSaidaArroba,
      "Mortes, cabeças ",
      this.resultados.produtivos.mortesCabecas],
                                
      ["GMD, kg/d ",
      this.resultados.produtivos.gmdKgd,
      "Ciclo produtivo, meses ",
      this.resultados.produtivos.cicloProdutivoMeses],
      
      ["Ganho de carcaça, kg/dia ",
      this.resultados.produtivos.ganhoCarcacaKgd,
      "Ciclo produtivo, dias ",
      this.resultados.produtivos.cicloProdutivoDias],

      ["Rendimento do ganho % ",
      this.resultados.produtivos.rendimentoGanho,                     
      "D1 do ciclo produtivo",
      this.resultados.produtivos.d1CicloProdutivo],

      ["Dias para ganhar 1 @ ",
      this.resultados.produtivos.diasParaGanhar1Arroba,
      "DZ do ciclo produtivo",
      this.resultados.produtivos.dzCicloProdutivo],

      ["Quantidade de @ ganhas por cab/mês ",
      this.resultados.produtivos.quantidadeArrobaGanhasCabecaMes,
      "Data do embarque",
      this.resultados.produtivos.dataEmbarque],

      ["Idade abate, meses ",
      this.resultados.produtivos.idadeAbateMeses,
      "Data do abate",
      this.resultados.produtivos.dataAbate],
                                  
      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Produtivos", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados Econômicos", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)


      //*
      //                         "Análise econômica geral"

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                  
      ["Ágio da @ de entrada ",
      this.resultados.economicos.analise.geral.agioEntrada +  " %",
      "Data da liquidação financeira ",
      this.resultados.economicos.analise.geral.dataLiquidacaoFinanceira],
                          
      ["Ciclo financeiro, meses ",
      this.resultados.economicos.analise.geral.cicloFinanceiroMeses]

      ]

      let subtitulo = {texto: "Análise econômica geral", subtitulo: true} 
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      this.configuraSubtitulo (opcoes)

      doc.autoTable(colunas, linhas, opcoes)

      //*
      //                          "Análise do custo de produção"

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                                
      ["Custo da nutrição por @ produzida",
      "R$ " + this.resultados.economicos.analise.custo.custoNutricaoArrobaProduzida + " /@",
      "Outros custos por @ produzida",
      "R$ " + this.resultados.economicos.analise.custo.outrosCustosArrobaProduzida + " /@"],
                                
      ["Despesas por @ produzida",
      "R$ " + this.resultados.economicos.analise.custo.despesasArrobaProduzida + " /@",
      "Custo por @ produzida",
      "R$ " + this.resultados.economicos.analise.custo.custoArrobaProduzida + " /@"],
                                
      ["Custo da @ de entrada (magra) ",
      "R$ " + this.resultados.economicos.analise.custo.custoArrobaEntradaMagra + " /@",
      "Custo da @ vendida",
      "R$ " + this.resultados.economicos.analise.custo.custoArrobaVendida + " /@"],
                                
      ["Custeio ao mês ",
      "R$ "  + this.resultados.economicos.analise.custo.custeioMes + " /cab",
      "Custeio ao dia ",
      "R$ "  + this.resultados.economicos.analise.custo.custeioDia + " /cab"],
                                
      ["Custeio total",
      "R$ " + this.resultados.economicos.analise.custo.custeioTotal + " /cab",
      "Custo variável do custeio ",
      this.resultados.economicos.analise.custo.custoVariavelCusteio + " %"],

      ["Custo fixo, % do custeio ",
      this.resultados.economicos.analise.custo.custoFixoCusteio + " %",
      "Custo variável nutricional ao mês ",
      "R$ " + this.resultados.economicos.analise.custo.custoVariavelNutricional + " /cab"],

      ["Custo do animal vendido, R$/@ (incluso imposto)",
      "R$ " + this.resultados.economicos.analise.custo.custoAnimalVendidoInclusoImposto + " /@",
        "Ponto de equilíbrio do custeio ao mês",
      "R$ " + this.resultados.economicos.analise.custo.pontoEquilibrioCusteio + " /cab"],

      ]

      subtitulo = {texto: "Análise do custo de produção", subtitulo: true} 
      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, subtitulo)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;

      this.configuraSubtitulo (opcoes)

      doc.autoTable(colunas, linhas, opcoes)


      //                        
      //                       "DRE do animal, sem considerar mortalidade"


      colunas =  ['',
      '',
      '',
      '']

      linhas = [   

      ["Receita Operacional Bruta (ROB), R$/cab ",    
      "R$ " + this.resultados.economicos.dre.receitaOperacionalBruta + " /cab",
      "Amortização, R$/cab ",
      "R$ " + this.resultados.economicos.dre.amortizacao],


      ["Deduções, R$/cab ",
      "R$ " + this.resultados.economicos.dre.deducoes + " /cab",
      "EBTI (Result Operacional), R$/cab ",
      "R$ " + this.resultados.economicos.dre.ebit + " /cab"] ,

        
      ["Receita Operacional Líquida (ROL), R$/cab ",
      "R$ " + this.resultados.economicos.dre.receitaOperacionalLiquida + " /cab",
      "Financeiro, R$/cab ",
      "R$ " + this.resultados.economicos.dre.financeiro + " /cab"] ,


      ["Custo do produto vendido (CPV), R$/cab ",
      "R$ " + this.resultados.economicos.dre.custoProdutoVendido + " /cab",
      "Não operacional, R$/cab ",
      "R$ " + this.resultados.economicos.dre.naoOperacional + " /cab"] ,
        
      ["Lucro Bruto, R$/cab ",
      "R$ " + this.resultados.economicos.dre.lucroBruto + " /cab",
      "Lucro antes do I.R.(LAIR), R$/cab ",
      "R$ " + this.resultados.economicos.dre.lucroAntesImpostoRenda + " /cab"] ,


      ["Despesa total, R$/cab ",
      "R$ " + this.resultados.economicos.dre.despesaTotal + " /cab",
      "Valor do I.R., R$/cab ",
      "R$ " + this.resultados.economicos.dre.valorImpostoRenda + " /cab"] ,
      

      ["EBITDA (Resultado Operacional), R$/cab ",
      "R$ " + this.resultados.economicos.dre.ebitda + " /cab",
      "Lucro líquido, R$/cab ",
      "R$ " + this.resultados.economicos.dre.lucroLiquido + " /cab"] ,
      
      ["Depreciação, R$/cab ",
      "R$ " + this.resultados.economicos.dre.depreciacao + " /cab"] ,

       
                              

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "DRE do animal, sem considerar mortalidade", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)


      //*
      //*                           "Análise do ponto de equlíbrio (breakeven)"

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                                
      ["Ponto de equilíbrio da @ vendida, R$/@ bruto ",
      this.resultados.economicos.analise.breakeven.pontoEquilibrioArrobaVendidaBruto,
      "Ponto de equilíbrio do valor do gado, R$/cab ",
      this.resultados.economicos.analise.breakeven.pontoEquilibrioValorGado]

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Ponto de equlíbrio", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      //
      //*                            "Análise econômica principal"

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                                
      ["Taxa mínima de atratividade ('i' ou TMA) ",
      this.resultados.economicos.analise.principal.taxaMinimaAtratividade + " %",
      "Preço por @ vendida, R$/@ bruto ",
      "R$ " + this.resultados.economicos.analise.principal.precoArrobaVendidaBruto + " /@"],
                          
      ["Preço por @ vendida, R$/@ livre ",
      "R$ " + this.resultados.economicos.analise.principal.precoArrobaVendidaLivre + " /@",
      "Margem por @ vendida, R$/@ livre ",
      "R$ " + this.resultados.economicos.analise.principal.margemArrobaVendidaLivre + " /@"],
                          
      ["Lucratividade da operação ",
      "R$ " + this.resultados.economicos.analise.principal.lucratividadeOperacao,
      "Rentabilidade da operação ",
      this.resultados.economicos.analise.principal.rentabilidadeOperacao + " %"],
                          
      ["Margem EBITDA ",
      this.resultados.economicos.analise.principal.margemEBITDA + " %"]

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Análise econômica principal", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      //
      //*                      "Análise de viabilidade do projeto, considerando as perdas com mortalidade "
                                

      colunas =  ['',
      '',
      '',
      '']

      linhas = [   

      ["Capital investido ",
      "R$ " + this.resultados.economicos.analise.viabilidade.capitalInvestido,
      "Valor futuro aplicação em gado ",
      "R$ " + this.resultados.economicos.analise.viabilidade.valorFuturoAplicacaoGado],
                          
      ["Valor futuro aplicação financeira ",
      "R$ " + this.resultados.economicos.analise.viabilidade.valorFuturoAplicacaoFinanceira,
      "Diferença da aplicação em gado / financeira ",
      "R$ " + this.resultados.economicos.analise.viabilidade.diferencaAplicacaoGadoFinanceira],
                          
      ["Lucro líquido do lote ",
      "R$ " + this.resultados.economicos.analise.viabilidade.lucroLiquidoLote,
      "Lucro líquido de cada animal do lote ",
      "R$ " + this.resultados.economicos.analise.viabilidade.lucroLiquidoCadaAnimalLote],
                          
      ["Índice de lucratividade ",
      this.resultados.economicos.analise.viabilidade.indiceLucratividade,
      "Taxa interna de retorno (TIR)",
      this.resultados.economicos.analise.viabilidade.taxaInternaRetorno + " %"],
                          
      ["Valor presente líquido (VPL)",
      "R$ " + this.resultados.economicos.analise.viabilidade.valorPresenteLiquido,
      "Taxa mensal do capital investido em gado ",
      this.resultados.economicos.analise.viabilidade.taxaMensalCapitalInvestidoGado + " %"],

      ["","","",""],
      ["","","",""]

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Análise de viabilidade do projeto, considerando as perdas com mortalidade", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      //*
      //                       "RESULTADOS POR ÁREA"

                          
      colunas =  ['',
      '',
      '',
      '']

      linhas = [   
                              
      ["Produção, @/há ",
      this.resultados.area.balanco.producao,
      "Custeio, @/há ",
      this.resultados.area.balanco.custeio],
                          
      ["Ágio, @/há ",
      this.resultados.area.balanco.agio,
      "Outros desembolsos, @/há ",
      this.resultados.area.balanco.outrosDesembolsos],
                          
      ["Margem líquida, @/há ",
      this.resultados.area.balanco.margemLiquida,
      "Lotação média do ciclo produtivo, cab/há ",
      this.resultados.area.principal.lotacaoMediaCicloProdutivo],
                            
      ["Perfil de peso médio do animal, UA/cab ",
      this.resultados.area.principal.perfilPesoMedioAnimalUA,
      "Produtividade, @ prod/há ciclo produtivo ",
      this.resultados.area.principal.produtividadeArrobaCicloProdutivo],
                            
      ["Produtividade, @ prod/há ciclo anualizado ",
      this.resultados.area.principal.produtividadeArrobaCicloAnualizado,
      "UA/há, médio do ciclo produtivo ",
      this.resultados.area.principal.uaMedioCicloProdutivo],
                            
      ["EBITDA, R$/há/ciclo produtivo ",
      "R$ " + this.resultados.area.principal.ebitdaCicloProdutivo,
      "EBITDA, R$/há/ciclo anualizado ",
      "R$ " + this.resultados.area.principal.ebitdaCicloAnualizado],
                            
      ["Lucro líquido, R$/há/ciclo produtivo ",
      "R$ " + this.resultados.area.principal.lucroLiquidoCicloProdutivo,
      "Lucro líquido, R$/há/ciclo anualizado ",
      "R$ " + this.resultados.area.principal.lucroLiquidoCicloAnualizado],
      

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Resultados por área", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)


      colunas =  ["","","",""]

      linhas = [   
                            
      ["Lotação fase 1, UA/há ",
      this.resultados.area.principal.lotacaoFase_1,
      //                     if = "resultados.area.principal.lotacaoFase_2 !== 'Sem dados'"
      "Lotação fase 2, UA/há ",
      this.resultados.area.principal.lotacaoFase_2],
      //                     if = "resultados.area.principal.lotacaoFase_3 !== 'Sem dados'">,
      ["Lotação fase 3, UA/há ",
      this.resultados.area.principal.lotacaoFase_3,
      //                     if = "resultados.area.principal.lotacaoFase_4 !== 'Sem dados'">
      "Lotação fase 4, UA/há ",
      this.resultados.area.principal.lotacaoFase_4],
      //                      if resultados.area.principal.lotacaoFase_5 !== 'Sem dados'">
      ["Lotação fase 5, UA/há ",
      this.resultados.area.principal.lotacaoFase_5, 
      //                     if="resultados.area.principal.lotacaoFase_6 !== 'Sem dados'">
      "Lotação fase 6, UA/há ",
      this.resultados.area.principal.lotacaoFase_6], 
      //                     <tr v-if="resultados.area.principal.lotacaoFase_7 !== 'Sem dados'">
      ["Lotação fase 7, UA/há ",
      this.resultados.area.principal.lotacaoFase_7, 
      //                    <tr v-if="resultados.area.principal.lotacaoFase_8 !== 'Sem dados'">
      "Lotação fase 8, UA/há ",
      this.resultados.area.principal.lotacaoFase_8]

      ]

      resp = this.gerarOpcoes(doc, espacamento, numeroPagina, linhas, "Análise do custo de produção", false)
      opcoes = resp.opcoes;
      numeroPagina = resp.numeroPagina;
      espacamento = resp.espacamento;
      doc.autoTable(colunas, linhas, opcoes)

      doc.save(this.nomeArquivo)
    }
  }
}

 



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Simulacoes/Relatorios/Consolidado/Completo/Pasto/Exports/ExportarPDFeXLSController.js